import React from "react";
import { Redirect, Switch, Route as RouterRoute } from "react-router-dom";

import Route from "./Route";

import SignIn from "../pages/SignIn";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Layout from "../pages/Layout";
import Profile from "../pages/Profile";

const Routes: React.FC = () => {
  return (
    <Switch>
      <RouterRoute path="/" exact>
        <Redirect to="/app" />
      </RouterRoute>
      <Route path="/app" component={Layout} isPrivate />

      <Route path="/login" component={SignIn} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/reset-password" component={ResetPassword} />

      <Route path="/profile" component={Profile} isPrivate />
    </Switch>
  );
};

export default Routes;
